import React from 'react'
import './Navbar.scss'

const Navbar = () => {

    const handleLogoClick = () => {
        let redirectUrl = "https://atlasathlete.ai/";

        window.location.href = redirectUrl;
    };

    return (
        <nav className="navbar">
            <div className="navbar__container">
                <div className="logo-wrapper">
                    <img
                        src="/assets/images/logo1.png"
                        alt="Logo"
                        width={175}
                        onClick={handleLogoClick}
                    />
                </div>
            </div>
        </nav>
    )
}
export default Navbar
